
var logger = require('../logger/logger');
var loggerUtils = require('../logger/utils.js');
var stringUtil = require('../string/stringUtil.js')
var hardwareChannel = require('../messaging/hardware/hardwareChannel.js')
var commonUtility = require('../domain/commonUtility.js')
var printSettingsUtils = require('../domain/settings/printSettingsUtils')
const qrScannerUtil = require('../qrScanner/qrScannerUtil');

module.exports.openCashDrawer = function()
{
    try
    {
        var cashDrawerPayload = {};
        cashDrawerPayload.type = "hardware";
        cashDrawerPayload.subType = "open.cash.drawer";
        this.enrichPrintPayload(cashDrawerPayload);
        cashDrawerPayload.tracingContext = loggerUtils.createTracingContext("hardware.channel", cashDrawerPayload.subType);
    
        if (stringUtil.isStringNullOrEmpty(cashDrawerPayload.terminalCode) || stringUtil.isStringNullOrEmpty(cashDrawerPayload.printerName))
        {
            logger.warn("Either terminal Code or printer name is missing so ignoring the call for opening cash drawer request");
            return;
        }
    
        logger.info(`Sending an opening cash drawer request [terminal code: ${cashDrawerPayload.terminalCode} and printer name: ${cashDrawerPayload.printerName}]`);
        hardwareChannel.publishMessage(cashDrawerPayload); 
    }
    catch(error)
    {
        logger.error(`Error occurred while opening a cash drawer. ${error}`, null, error);
    }
}

module.exports.printSaleReceipt = function (receiptPrintPayload)
{
    try
    {
        receiptPrintPayload.type = "hardware";
        receiptPrintPayload.subType = "sale.receipt.print";
        this.enrichPrintPayload(receiptPrintPayload);
        receiptPrintPayload.tracingContext = loggerUtils.createTracingContext("hardware.channel", receiptPrintPayload.subType);
        receiptPrintPayload.tracingContext.originOrderNumber = receiptPrintPayload.orderNumber;
        receiptPrintPayload.tracingContext.originOrderVenue = receiptPrintPayload.venue;
        receiptPrintPayload.tracingContext.originOrderDispatchType = receiptPrintPayload.dispatchType;


        if (stringUtil.isStringNullOrEmpty(receiptPrintPayload.terminalCode) || stringUtil.isStringNullOrEmpty(receiptPrintPayload.printerName))
        {
            logger.warn("Either terminal Code or printer name is missing so ignoring the call for sale receipt printing");
            return;
        }

        logger.info(`Sending a sale receipt printing request [terminal code: ${receiptPrintPayload.terminalCode} and printer name: ${receiptPrintPayload.printerName}]`);
        hardwareChannel.publishMessage(receiptPrintPayload);
        
    }
    catch(error)
    {
        logger.error(`Error occurred while sending a print request [terminal code: ${receiptPrintPayload.terminalCode} and printer name: ${receiptPrintPayload.printerName}].`, {}, error);
    }
}

module.exports.printKitchenTicket = function (sale, numberOfCopies)
{
    try
    {
        var kitchenPrintPayload = {};
        kitchenPrintPayload.sale = sale;
        kitchenPrintPayload.quantity = numberOfCopies;
        kitchenPrintPayload.type = "hardware";
        kitchenPrintPayload.subType = "kitchen.duplicate.print";
        kitchenPrintPayload.tracingContext = loggerUtils.createTracingContext("sales.channel", kitchenPrintPayload.subType);
        kitchenPrintPayload.tracingContext.originOrderNumber = sale.number;
        kitchenPrintPayload.tracingContext.originOrderVenue = sale.venueCode;
        kitchenPrintPayload.tracingContext.originOrderDispatchType = sale.dispatchType;
        
        
        logger.info("Sending a kitchen ticket printing request");
        hardwareChannel.publishMessage(kitchenPrintPayload);
    }
    catch(error)
    {
        logger.error('Error occurred while sending a kitchen print ticket. ', {}, error);
    }
}

module.exports.printTillSaleReport = function (reportPrintPayload)
{
    try
    {
        reportPrintPayload.type = "hardware";
        reportPrintPayload.subType = "till.sale.report.print";
        this.enrichPrintPayload(reportPrintPayload);
        reportPrintPayload.tracingContext = loggerUtils.createTracingContext("hardware.channel", reportPrintPayload.subType);

        if (stringUtil.isStringNullOrEmpty(reportPrintPayload.terminalCode) || stringUtil.isStringNullOrEmpty(reportPrintPayload.printerName))
        {
            logger.warn("Either terminal Code or printer name is missing so ignoring the call for till report printing");
            return;
        }
    
        logger.info(`Sending a till report printing request [terminal code: ${reportPrintPayload.terminalCode} and printer name: ${reportPrintPayload.printerName}]`);
        hardwareChannel.publishMessage(reportPrintPayload);
    }
    catch(error)
    {
        logger.error(`Error occurred while sending a print request [terminal code: ${reportPrintPayload.terminalCode} and printer name: ${reportPrintPayload.printerName}]`, {}, error);
    }
}

module.exports.printDriverSaleReport = function (reportPrintPayload)
{
    try
    {
        reportPrintPayload.type = "hardware";
        reportPrintPayload.subType = "reports.driverSalesReport";
        this.enrichPrintPayload(reportPrintPayload);
        reportPrintPayload.tracingContext = loggerUtils.createTracingContext("hardware.channel", reportPrintPayload.subType);

        if (stringUtil.isStringNullOrEmpty(reportPrintPayload.terminalCode) || stringUtil.isStringNullOrEmpty(reportPrintPayload.printerName))
        {
            logger.warn("Either terminal Code or printer name is missing so ignoring the call for driver report printing request");
            return;
        }

        logger.info(`Sending a 'report.driverSalesReport' printing request [terminal code: ${reportPrintPayload.terminalCode} and printer name: ${reportPrintPayload.printerName}]`);

        hardwareChannel.publishMessage(reportPrintPayload);
    }
    catch (error)
    {
        logger.error(`Error occurred while sending a print request. [terminal code: ${reportPrintPayload.terminalCode} and printer name: ${reportPrintPayload.printerName}]`, {}, error);
    }
}

module.exports.printCardSignatureVerification = function(merchantLines)
{
    var signatureCardPrintPayload = {};
    signatureCardPrintPayload.type = "hardware";
    signatureCardPrintPayload.subType = "sale.verify.signature.print";
    signatureCardPrintPayload.merchantLines = JSON.stringify(merchantLines)
    this.enrichPrintPayload(signatureCardPrintPayload);
    signatureCardPrintPayload.tracingContext = loggerUtils.createTracingContext("hardware.channel", signatureCardPrintPayload.subType);

    if (stringUtil.isStringNullOrEmpty(signatureCardPrintPayload.terminalCode) || stringUtil.isStringNullOrEmpty(signatureCardPrintPayload.printerName))
    {
        logger.warn("Either terminal Code or printer name is missing so ignoring the call for card signature printing request");
        return;
    }

    logger.info(`Sending a card signature printing request [terminal code: ${signatureCardPrintPayload.terminalCode} and printer name: ${signatureCardPrintPayload.printerName}]`);
    hardwareChannel.publishMessage(signatureCardPrintPayload);       

}

module.exports.printFloatSessionReport = function (printPayload)
{
    try
    {
        printPayload.type = "hardware";
        printPayload.subType = "float.session.print";
        this.enrichPrintPayload(printPayload);
        printPayload.tracingContext = loggerUtils.createTracingContext("hardware.channel", printPayload.subType);

        if (stringUtil.isStringNullOrEmpty(printPayload.terminalCode) || stringUtil.isStringNullOrEmpty(printPayload.printerName))
            return;
    
        hardwareChannel.publishMessage(printPayload);
    }
    catch(error)
    {
        logger.error('Error occurred while sending a print request. ' + error, {}, error);
    }
}

module.exports.printVoucherCode = function (offer, voucherNumber, voucherId, startDate, expiryDate)
{
    try
    {
        const receiptPrintPayload = {};
        receiptPrintPayload.type = "hardware";
        receiptPrintPayload.subType = "voucher.code.print";
        this.enrichPrintPayload(receiptPrintPayload);
        receiptPrintPayload.tracingContext = loggerUtils.createTracingContext("hardware.channel", receiptPrintPayload.subType);

        receiptPrintPayload.offer = offer;
        receiptPrintPayload.issueDate = startDate;
        receiptPrintPayload.expiryDate = expiryDate;
        receiptPrintPayload.code = voucherNumber;
        receiptPrintPayload.qrCode = qrScannerUtil.createVoucherQRCode(voucherId);

        if (stringUtil.isStringNullOrEmpty(receiptPrintPayload.terminalCode) || stringUtil.isStringNullOrEmpty(receiptPrintPayload.printerName))
            return;
    
        hardwareChannel.publishMessage(receiptPrintPayload);
    } 
    catch(error)
    {
        logger.error('Error occurred while sending a print request. ' + error, {}, error);
    }
}

module.exports.printDailySummaryReport = function (reportPrintPayload)
{
    try
    {
        reportPrintPayload.type = "hardware";
        reportPrintPayload.subType = "reports.dailySummaryReport";
        this.enrichPrintPayload(reportPrintPayload);
        reportPrintPayload.tracingContext = loggerUtils.createTracingContext("hardware.channel", reportPrintPayload.subType);

        if (stringUtil.isStringNullOrEmpty(reportPrintPayload.terminalCode) || stringUtil.isStringNullOrEmpty(reportPrintPayload.printerName))
        {
            logger.warn("Either terminal Code or printer name is missing so ignoring the call for driver report printing request");
            return;
        }

        logger.info(`Sending a 'report.dailySummaryReport' printing request [terminal code: ${reportPrintPayload.terminalCode} and printer name: ${reportPrintPayload.printerName}]`);
        hardwareChannel.publishMessage(reportPrintPayload);
    }
    catch (error)
    {
        logger.error(`Error occurred while sending a print request. [terminal code: ${reportPrintPayload.terminalCode} and printer name: ${reportPrintPayload.printerName}]`, {}, error);
    }
}

module.exports.enrichPrintPayload = function (printPayload)
{
    var printConfiguration = commonUtility.getPropertyPrintConfiguration();
    var property = commonUtility.getProperty();

    printPayload.printerName = null;
    printPayload.terminalCode = null;
    printPayload.title = null;
    printPayload.footer = null;

    if (stringUtil.isStringNullOrEmpty(printSettingsUtils.getReceiptPrinter()))
        return;

    var printerUrl = printSettingsUtils.getReceiptPrinter();
    
    var urlComponents = printerUrl.split('/');
    if (urlComponents.length < 2)
        return;

    var terminalCode = stringUtil.trimString(urlComponents[0]);
    var printerName = stringUtil.trimString(urlComponents[1]);

    if (stringUtil.isStringNullOrEmpty(terminalCode) || stringUtil.isStringNullOrEmpty(printerName))
        return;

    printPayload.printerName = printerName;
    printPayload.terminalCode = terminalCode;
    printPayload.title =  printConfiguration.printingHeader;
    printPayload.footer = printConfiguration.printingFooter;
    printPayload.vatRegistrationNumber = property.vatRegistrationNumber;
}